import { FormCheck, FormControl, FormLabel } from "react-bootstrap";
import { IFieldEditor } from "../../../../models/Interfaces";
import React from "react";
import FormCheckInput from "react-bootstrap/esm/FormCheckInput";

const CheckedEditor = (props: IFieldEditor) => {

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    props.onValueChange(props.property.Id, checked.toString());
  }

  return (
    <>
      <FormLabel htmlFor={`check-${props.property.Id}`}>{props.property.DisplayLabel}</FormLabel>
      <FormCheckInput 
        id={`check-${props.property.Id}`}
        name={`check-${props.property.Id}`}
        type="checkbox" 
        className="form-check"
        onChange={handleChange}
        checked={
          props.property.PublishedValue === "true" || 
          (!props.property.PublishedValue && props.property.DefaultValue === "true")
        }
      />  
    </>
  );
}

export default CheckedEditor;